import * as Yup from 'yup';

export const loginSchema = Yup.object({
    email: Yup.string().email().required('Please Enter your Email Address'),
    password: Yup.string()
        .required('Password is required')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
            'Password must include at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.'
        ),
})

export const forgotPasswordSchema = Yup.object({
    email: Yup.string().email().required('Please Enter your Email Address'),
})

export const resetPasswordSchema = Yup.object({
    password: Yup.string()
        .required('New Password is required')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
            'Password must include at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.'
        ),


    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
})

export const changResPaaSchema = Yup.object({
    oldpassword: Yup.string()
        .required('old Password is required')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
            'Password must include at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.'
        ),

    password: Yup.string()
        .required('Password is required')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/,
            'Password must include at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.'
        ),


    confirmpassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
})

const profileSchema = (otpRequested) =>
    Yup.object().shape({
        // image: Yup.mixed()
        //     .test('required-image', 'Image is required', (value) => {
        //         if (!value) return false; // No image at all
        //         if (typeof value === 'string') return true; // Existing image URL
        //         if (value instanceof File)
        //             return ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
        //         return false;
        //     })
        //     .test('fileFormat', 'Unsupported file format', (value) => {
        //         if (!value || typeof value === 'string') return true; // skip format check for URL
        //         return ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
        //     }),
        roleID: Yup.string(),
        roleName: Yup.string(),
        name: Yup.string(),
        email: Yup.string().email(),
        mobile: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits')
            .required('Mobile number is required'),
        otp: otpRequested
            ? Yup.string().matches(/^\d{4}$/, 'OTP must be exactly 4 digits')
                .required('OTP is required')
            : Yup.string().notRequired(),
    });
export { profileSchema };


const statementSchema = Yup.object().shape({
    startDate: Yup.string().required('Start Date is required'),
    endDate: Yup.string().required('End Date is required'),
    startTime: Yup.string().required('Start Time is required'),
    endTime: Yup.string().required('End Time is required'),
    totalDisruption: Yup.string().required('Total Disruption is required'),
    subjectMatterDetails: Yup.string().required('Subject Matter Details is required'),

    statemenatIssuer: Yup.object().shape({
        name: Yup.string().required('Name is required'),
        staffNumber: Yup.string().required('Staff Number is required'),
        company: Yup.string().required('Company is required'),
        contactNumber: Yup.string().required('Contact Number is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        shiftTimings: Yup.string().required('Shift Timings are required'),
    }),

    airsideLeadInspector: Yup.object().shape({
        staffName: Yup.string().required('Staff Name is required'),
        staffNumber: Yup.string().required('Staff Number is required'),
        contactNumber: Yup.string().required('Contact Number is required'),
        date: Yup.string().required('Date is required'),

        leadInspector: Yup.string().required('Lead Inspector is required'),
    }),

    witnessStatementIssuer: Yup.object().shape({
        staffName: Yup.string().required('Staff Name is required'),
        staffNumber: Yup.string().required('Staff Number is required'),
        contactNumber: Yup.string().required('Contact Number is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        shiftTimings: Yup.string().required('Shift Timings are required'),
        date: Yup.string().required('Date is required'),
        statementIssuer: Yup.string().required('Statement Issuer is required'),
    }),
});

export const statementFrmvalidationSchema = Yup.object().shape({
    statements: Yup.array().of(statementSchema).min(1, 'At least one statement is required'),
});

const departmentValidationSchema = (department) => {
    const baseSchema = Yup.object().shape({
        subExactCoordinates: Yup.string().required('Map Location is required'),
        incidentLocationHotspot: Yup.string().required('Is Incident Location a Known Hotspot? is required'),

        severitys: Yup.string().required('Severity Level is required'),
        likeliHood: Yup.string().required('Likelihood is required'),


        detailedImage: Yup.string().required('Detailed Image is required'),


        shortDescription: Yup.string().required('Short Description is required'),
        detailedDescription: Yup.string().required('Detailed Description is required'),
        immediateActionsTaken: Yup.string().required('immediate Actions Taken is required'),

        reportedBy: Yup.string().required('Reported By is required'),
        createdBy: Yup.string().required('Created By is required'),
    });

    switch (department) {
        case 'AOCC':
            return baseSchema.shape({
                dPersonName: Yup.string().required('Person name is required'),
                dActionTime: Yup.string().required('Action time is required'),
            });

        case 'HSSE':
            return baseSchema.shape({
                hPersonName: Yup.string().required('Person name is required'),
                approvalTime: Yup.string().required('Approval time is required'),
            });

        case 'AIRSIDE':
            return baseSchema.shape({
                leadOfficer: Yup.string().required('Lead officer is required'),
                actionTime: Yup.string().required('Action time is required'),
            });

        case 'FIRE':
            return baseSchema.shape({
                fireCommanderName: Yup.string().required('Commander name is required'),
                fActionTaken: Yup.string().required('Action taken is required'),
            });

        case 'TERMINAL':
            return baseSchema.shape({
                terminalSupervisoronDuty: Yup.string().required('Supervisor name is required'),
                tActionTime: Yup.string().required('Action time is required'),
            });

        case 'ENGINEERING':
            return baseSchema.shape({
                ePersonName: Yup.string().required('Person Name is required'),
                eActionTime: Yup.string().required('Action Time is required'),
            });

        case 'OTHERS':
            return baseSchema.shape({
                othersPersonname: Yup.string().required('Person Name is required'),
                othersActionTime: Yup.string().required('Action Time is required'),
            });


        case 'AIRLINE':
            return baseSchema.shape({
                airlinePersonName: Yup.string().required('Person Name is required'),
                airlineArrivalTime: Yup.string().required('Arrival Time is required'),
            });

        default:
            return baseSchema;
    }
};
export { departmentValidationSchema };


const wasInvolvedFrmvalidationSchema = Yup.object().shape({
    wasInvolved: Yup.array().of(
        Yup.object().shape({
            nameofPerson: Yup.string().trim().required('Name of Person is required'),
            staffCategory: Yup.string().required('Staff Category is required'),
            designation: Yup.string().required('Designation is required'),
            staffIdentificationNo: Yup.string().required('Staff Identification No is required'),
            staffShiftTiming: Yup.mixed().required('Staff Shift Timing is required'),
            staffContactDetails: Yup.string().required('Staff Contact Details are required'),
            staffEmail: Yup.string().email('Invalid email format').required('Staff Email is required'),
            //images: Yup.mixed().notRequired(), // Modify if you're handling uploads
        })
    )
});
export { wasInvolvedFrmvalidationSchema };


export const VehicleEquipmentRelatedFrmvalidationSchema = Yup.object().shape({
    vehicleEquipmentNo: Yup.string().required('Vehicle/Equipment No is required'),
    vehicleType: Yup.string().required('Vehicle Type is required'),
    driverDetails: Yup.string().required('Driver Details are required'),
    licenseDetails: Yup.string().required('License Details are required'),
    departmentOperatorName: Yup.string().required('Department / Operator Name is required'),

    aircraftInvolved: Yup.string().required('Aircraft Involved selection is required'),

    aircraftRegistration: Yup.string().when('aircraftInvolved', {
        is: val => val === 'yes',
        then: schema => schema.required('Aircraft Registration is required'),
        otherwise: schema => schema.notRequired()
    }),
    aircraftType: Yup.string().when('aircraftInvolved', {
        is: val => val === 'yes',
        then: schema => schema.required('Aircraft Type is required'),
        otherwise: schema => schema.notRequired()
    }),
    airlineOperator: Yup.string().when('aircraftInvolved', {
        is: val => val === 'yes',
        then: schema => schema.required('Airline / Operator is required'),
        otherwise: schema => schema.notRequired()
    }),
    originDestination: Yup.string().when('aircraftInvolved', {
        is: val => val === 'yes',
        then: schema => schema.required('Origin / Destination is required'),
        otherwise: schema => schema.notRequired()
    }),
    flightNumber: Yup.string().when('aircraftInvolved', {
        is: val => val === 'yes',
        then: schema => schema.required('Flight Number is required'),
        otherwise: schema => schema.notRequired()
    }),
    operationalImpact: Yup.string().when('aircraftInvolved', {
        is: val => val === 'yes',
        then: schema => schema.required('Operational Impact is required'),
        otherwise: schema => schema.notRequired()
    }),

    damageCaused: Yup.string().required('Damage Caused selection is required'),
});


const DescriptionvalidationSchema = Yup.object().shape({
    shortDescription: Yup.string().required('Short Description is required'),
    detailedDescription: Yup.string().required('Detailed Description is required')
});

export { DescriptionvalidationSchema };


const ActiondepartmentValidationSchema = (department) => {
    const baseSchema = Yup.object().shape({
    });

    switch (department) {
        case 'AOCC':
            return baseSchema.shape({
                dPersonName: Yup.string().required('Person name is required'),
                dActionTime: Yup.string().required('Action time is required'),
                dActionTaken: Yup.string().required('Action taken is required'),
                dCommunicationLog: Yup.string().required('Communication log is required'),
            });

        case 'HSSE':
            return baseSchema.shape({
                hPersonName: Yup.string().required('Person name is required'),
                approvalTime: Yup.string().required('Approval time is required'),
                initialAssessment: Yup.string().required('Initial assessment is required'),
                recommendations: Yup.string().required('Recommendations are required'),
            });

        case 'AIRSIDE':
            return baseSchema.shape({
                leadOfficer: Yup.string().required('Lead officer is required'),
                actionTime: Yup.string().required('Action time is required'),
                actionTaken: Yup.string().required('Action taken is required'),
            });

        case 'FIRE':
            return baseSchema.shape({
                fireCommanderName: Yup.string().required('Commander name is required'),
                fireCategoryIncidentCode: Yup.string().required('Incident code is required'),
                unitDispatched: Yup.string().required('Unit dispatched is required'),
                unitArrivalTime: Yup.string().required('Arrival time is required'),
                fActionTaken: Yup.string().required('Action taken is required'),
            });

        case 'TERMINAL':
            return baseSchema.shape({
                terminalSupervisoronDuty: Yup.string().required('Supervisor name is required'),
                terminalEvacuationRequired: Yup.string().required('Evacuation status is required'),
                tActionTime: Yup.string().required('Action time is required'),
                passengerImpactAssessment: Yup.string().required('Passenger impact is required'),
            });

        case 'ENGINEERING':
            return baseSchema.shape({
                ePersonName: Yup.string().required('Person Name is required'),
                eActionTime: Yup.string().required('Action Time is required'),
                eOccurrenceType: Yup.string().required('Occurrence Type is required'),
                eLocation: Yup.string().required('Location is required'),
                eOtherOccurrenceType: Yup.string().when('eOccurrenceType', {
                    is: 'Other',
                    then: Yup.string().required('Please specify the occurrence type'),
                    otherwise: Yup.string()
                }),
                eOtherLocation: Yup.string()
                    .when('eLocation', {
                        is: 'Other',
                        then: Yup.string().required('Please specify the location'),
                        otherwise: Yup.string()
                    }),
                eSupervisorManagerNotified: Yup.string().required('Please indicate if the supervisor/manager was notified'),
                eFollowupRequired: Yup.string().required('Please indicate if follow-up is required'),
                eActionTaken: Yup.string().required('Action Taken is required'),
            });

        case 'OTHERS':
            return baseSchema.shape({
                othersPersonname: Yup.string().required('Person Name is required'),
                othersSpecifyDepartment: Yup.string().required('Specify Department is required'),
                othersActionTime: Yup.string().required('Action Time is required'),
                othersOccurrenceType: Yup.string().required('Occurrence Type is required'), // <-- must be BEFORE `.when()`s
                // othersDetails: Yup.string().when('othersOccurrenceType', {
                //     is: 'Other',
                //     then: Yup.string().required('Please specify Details'),
                //     otherwise: Yup.string()
                // }),
                // othersLocation: Yup.string().when('othersOccurrenceType', {
                //     is: 'Other',
                //     then: Yup.string().required('Please specify Location'),
                //     otherwise: Yup.string()
                // }),
                othersActionTaken: Yup.string().required('Action Taken is required'),
            });

        default:
            return baseSchema;
    }
};
export { ActiondepartmentValidationSchema };


